import { tv } from '@/utils/libs/tailwind-variants';
/**
 * HotlineLpSectionTop のスタイル
 */
export const hotlineLpSectionTopStyle = tv({
    slots: {
        base: ['relative xl:max-w-[1440px] mx-auto'],
        bgImageBox: [
            'absolute -z-10',
            'w-[104px] -top-[12px] -left-[54px]',
            'sm:w-[206px] sm:-top-24 sm:-left-[218px]',
            'md:-top-[28px] md:-left-[100px]',
            'lg:-left-[132px]',
            'xl:-top-[26px] xl:-left-[196px]',
            'min-[1440px]:-left-[132px]', // 144~
        ],
        button: ['mt-8 lg:mt-7 xl:mt-16'],
        description: [
            'text-[14px] sm:text-[16px] xl:text-[18px] text-[#231916]',
            'leading-[1.8] sm:leading-[32px] xl:leading-[2]',
            'sm:text-center md:text-left',
        ],
        imageBox: [
            'relative md:absolute top-0',
            'w-[124vw] h-[124vw] left-[6%] -top-[34dvw] max-sm:-mb-[34vw]',
            'sm:w-[114.5vw] sm:h-[114.5vw] sm:left-[14.7%] sm:-top-[46dvw] max-md:-mb-[46vw]',
            'md:w-[76vw] md:h-[76vw] md:left-[max(380px,40%)] md:-top-[20vw]',
            'lg:w-[76.7vw] lg:h-[76.7vw] lg:left-[41%] lg:-top-[28.2vw]',
            'xl:w-[85.4vw] xl:h-[85.4vw] xl:left-[35.8%] xl:-top-[33.6vw]',
            'min-[1440px]:w-[min(1461px,76vw)] min-[1440px]:h-[min(1461px,76vw)] min-[1440px]:left-[35.2%] ',
            'min-[1440px]:-top-[min(25vw,486px)]',
        ],
        relative: 'relative',
        subTitle: [
            'text-[14px] font-bold text-[#4881F1]',
            'sm:text-[20px] xl:text-[24px]',
            'max-md:text-center',
        ],
        textWrapper: [
            'relative flex flex-col gap-y-12 sm:gap-y-24',
            'lg:max-w-[1180px]',
            'md:mx-auto',
            'md:relative md:pt-[160px]',
            'md:px-64',
            'lg:px-48',
            'xl:px-32',
            'max-md:items-center max-md:mt-28',
            'z-10',
            'max-md:mx-32',
        ],
        title: [
            'text-[28px] sm:text-[44px] xl:text-[52px] font-bold text-[#231916]',
            'leading-[1.5] sm:leading-[70px] xl:leading-[1.6]',
            'mt-[10px] sm:mt-[21px]',
            'max-md:text-center',
        ],
    },
    variants: {},
});
